<div *ngIf="admonCatRemitenteStatus$ | async as usuariosStatus">
  <mat-card-content
    class="nuevo-catalogo-card"
    *ngIf="usuariosStatus.mostrarNuevo">
    <mat-card>
      <mat-card-header>
        <form
          [formGroup]="nuevoRegistro"
          class="nuevo-catalogo-form !grid !grid-cols-1 !gap-3">
          <h3 class="heading-3">Añadir Remitente o Destinatario</h3>

          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Nombre</mat-label>
            <input
              formControlName="nombre"
              name="nombre"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              placeholder="" />
            <mat-hint align="end"
              >{{ nuevoRegistro.get("apellido")?.value.length }} / 50</mat-hint
            >
            @if (nuevoRegistro.get('nombre')?.invalid &&
            nuevoRegistro.get('nombre')?.touched &&
            !nuevoRegistro.get('nombre')?.hasError('nombreRemitente')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (nuevoRegistro.get('nombre')?.invalid &&
            nuevoRegistro.get('nombre')?.touched &&
            nuevoRegistro.get('nombre')?.hasError('nombreRemitente')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Apellidos</mat-label>
            <input
              formControlName="apellido"
              name="apellido"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              placeholder="" />
            <mat-hint align="end"
              >{{ nuevoRegistro.get("apellido")?.value.length }} / 50</mat-hint
            >
            @if (nuevoRegistro.get('apellido')?.invalid &&
            nuevoRegistro.get('apellido')?.touched &&
            !nuevoRegistro.get('apellido')?.hasError('nombreRemitente')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (nuevoRegistro.get('apellido')?.invalid &&
            nuevoRegistro.get('apellido')?.touched &&
            nuevoRegistro.get('apellido')?.hasError('nombreRemitente')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Email</mat-label>
            <input
              formControlName="mail"
              name="mail"
              class="nuevo-catalogo-input"
              type="email"
              maxlength="50"
              matInput
              (input)="existeRegistro(nuevoRegistro.get('mail'), '')"
              placeholder="" />
            @if (nuevoRegistro.get('mail')?.invalid &&
            nuevoRegistro.get('mail')?.touched &&
            !nuevoRegistro.get('mail')?.hasError('mailDuplicad@')&&
            !nuevoRegistro.get('mail')?.hasError('invalidEmail')) {
            <mat-error>Campo obligatorio</mat-error>
            }

            <mat-error
              *ngIf="nuevoRegistro.get('mail')?.hasError('mailDuplicad@')">
              El correo ya se encuentra registrado.
            </mat-error>
            <mat-error
              *ngIf="nuevoRegistro.get('mail')?.hasError('invalidEmail')">
              {{
                " El correo electrónico proporcionado es incorrecto, por favor
             ingréselo en el siguiente formato: usuario/a@dominio Ej:
             ejemplo@dominio.com.mx"
              }}
            </mat-error>
          </mat-form-field>
        </form>
      </mat-card-header>
      <mat-card-actions align="end" class="nuevo-catalogo-actions">
        <button
          class="!uppercase"
          mat-stroked-button
          type="button"
          (click)="cancelar()">
          CANCELAR
        </button>
        <button
          class="!uppercase"
          mat-flat-button
          type="button"
          (click)="guardarRegistro()"
          color="primary"
          [disabled]="nuevoRegistro.invalid || existe">
          GUARDAR
        </button>
      </mat-card-actions>
    </mat-card>
  </mat-card-content>
</div>
